/** New Soft Release / Super Soft Release (needs the kind's permission). */
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { SOFT_RELEASE_KINDS, SOFT_RELEASE_PERMISSION } from "@nexseed/shared";
import { useAuth } from "@/features/auth/store";
import { SoftReleaseNewPage } from "@/features/quality/components/soft-release/soft-release-new-page";

export const Route = createFileRoute("/_app/quality/releases/$kind/new")({
  params: {
    parse: ({ kind }) => {
      if (!(SOFT_RELEASE_KINDS as readonly string[]).includes(kind))
        throw notFound();
      return { kind: kind as (typeof SOFT_RELEASE_KINDS)[number] };
    },
    stringify: (p) => p,
  },
  beforeLoad: ({ params }) => {
    if (!useAuth.getState().can(SOFT_RELEASE_PERMISSION[params.kind]))
      throw redirect({ to: "/quality/releases/$kind", params });
  },
  component: Page,
});

function Page() {
  const { kind } = Route.useParams();
  return <SoftReleaseNewPage kind={kind} />;
}
